<svelte:options accessors/>
<script>

import { createEventDispatcher } from 'svelte';
import Button from '../button.svelte';

const dispatch = createEventDispatcher();


export let code = '';
export let error = '';

let applying = false;

$:applyButtonState = (applying && !error) ? 'loading': '';

export function SetError(e)
{
    error = e;
}

export function CanClose(withCode)
{
    return !applying || withCode == MODAL_OK;
}

function Apply()
{
    if (!code)
        return;

    error = false;
    applying = true;

    //applying = true;

    //HideModal(MODAL_OK);
    // send the code the parent and wait
    dispatch('apply', {code});
}

function Cancel()
{
    HideModal(MODAL_CANCEL);
}

</script>

<div class="dialog">
  <section>
    <header style="display:flex; justify-content: center; margin-bottom: 1em;">
    </header>
  </section>

	 <section class="line-after">
      <header style="display:flex; justify-content: center;">
          <center>
            <h4>Add Discount</h4>
          </center>
      </header>
    </section>
    <div>
        {#if error}
            <p class="error">{error}</p>
        {/if}
        <form on:submit|preventDefault={Apply}>
            <div class="row gtr-uniform gtr-50">
              <div class="col-12 col-12-xsmall">
                  <input type="text" placeholder="CODE"  oninput="this.value=this.value.toUpperCase()" bind:value={code}/>
              </div>
              <div class="col-12 col-12-xsmall">
                <ul class="actions special">
                    <li>
                        <Button state={applyButtonState} class="button fit primary" text="Apply"/>
                    </li>
                        
                </ul>
              </div>
              <div class="col-12 col-12-xsmall">
                <ul class="actions special">
                    <li><button class="button fit" on:click={Cancel}>Cancel</button></li>
                </ul>
              </div>
            </div>
        </form>
    </div>
</div>

<style>

section.line-after:after {
  content: '';
  display: inline-block;
  width: 90%;
  height: 0.25rem;
  margin: 1em 5%;
  border-radius: 4px;
  background-color: #4a98e2;
}

h4, p, label, input
{
    color: black;
}

p.error
{
    color:red !important;
}

.dialog
{
    min-width: 300px;
    max-width: 400px;
    padding: 20px;
    z-index: 99;
    font-size: 13pt;
}

.button.primary {
  width: 100%;
  background-color: #4a98e2 !important;
}

li { width: 100%; }


@media screen and (max-width: 480px) {
    .dialog{
    max-width: 350px;
  }
}

@media screen and (max-width: 320px) {
    .dialog{
    width: 300px;
  }
}




</style>
